import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const Parallax = ({ src, range = 50, className = "", alt = "Apex" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [range, -range]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img src={src} alt={alt} style={{ y, scale: 1.18 }} className="w-full h-full object-cover" />
    </div>
  );
};

export const MaskReveal = ({ src, className = "", alt = "Apex" }) => (
  <motion.div
    initial={{ clipPath: "inset(100% 0px 0% 0px)" }}
    whileInView={{ clipPath: "inset(0% 0px 0% 0px)" }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
    className={`overflow-hidden ${className}`}
  >
    <img src={src} alt={alt} className="w-full h-full object-cover" />
  </motion.div>
);
